import * as React from "react";
import type { SVGProps } from "react";
const SvgIcImportanceLow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#EA2E2E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m5 8.5 7 7 7-7"
    />
  </svg>
);
export default SvgIcImportanceLow;
